import React from "react";
import { MDBModal, MDBModalBody } from "mdbreact";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ReceiptIcon from "@material-ui/icons/Receipt";

import { useTranslation } from "react-i18next";
import styles from "./PaymentModal.module.scss";

const PaymentConfirmationModal = ({
  month,
  isOpen,
  paymentSuccess,
  payableAmount,
  selectedStaff,
  handleToggle,
  paymentConfirmationIntent,
}) => {
  const {t} = useTranslation();

  return (
    <MDBModal isOpen={isOpen} toggle={handleToggle} centered disableBackdrop className={styles.paymentModal}>
      <MDBModalBody className={styles.paymentBody}>
        <button type="button" className={styles.closeButton} onClick={handleToggle} aria-label={t("Close")}>
          <CloseIcon />
        </button>
        <div className={styles.modalIcon}>
          {paymentSuccess ? <CheckCircleIcon /> : <ReceiptIcon />}
        </div>
        <div className={styles.modalHeader}>
          <span>{t("Payroll")}</span>
          <h3>{paymentSuccess ? t("Payment completed") : t("Payment Summary")}</h3>
          <p>{t("Confirm the selected staff payroll before continuing to payment.")}</p>
        </div>
        <div className={styles.summaryList}>
          <div>
            <span>{t("Month")}</span>
            <strong>{month}</strong>
          </div>
          <div>
            <span>{t("Total Staff Selected")}</span>
            <strong>{selectedStaff}</strong>
          </div>
          <div>
            <span>{t("Total Amount")}</span>
            <strong>{payableAmount}</strong>
          </div>
        </div>
        {paymentSuccess && (
          <div className={styles.successMessage}>
            <CheckCircleIcon />
            {t("Payment for above successfully completed")}
          </div>
        )}
        <div className={styles.modalActions}>
          {!paymentSuccess ? (
            <>
              <button type="button" className={styles.secondaryButton} onClick={handleToggle}>
                {t("Cancel")}
              </button>
              <button
                type="button"
                className={styles.primaryButton}
                onClick={() => {
                  paymentConfirmationIntent();
                  handleToggle();
                }}>
                {t("Go To Payment")}
              </button>
            </>
          ) : (
            <button type="button" className={styles.primaryButton} onClick={handleToggle}>
              {t("Ok")}
            </button>
          )}
        </div>
      </MDBModalBody>
    </MDBModal>
  );
};

export default PaymentConfirmationModal;
